import Vue from 'vue';
import Router from 'vue-router';
// 导入你的组件
import Home from '@/components/HomePage.vue';
import CompanyProfile from '@/components/CompanyProfile.vue';
import ProductsPage from '@/components/ProductsPage.vue';
import ProductsDetail from '@/components/ProductsDetail.vue';
import ContactUs from '@/components/ContactUs.vue';
import SuccessCases from '@/components/SuccessCases.vue';
import SalesGuarantee from '@/components/SalesGuarantee.vue'

Vue.use(Router);

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/company',
      name: 'CompanyProfile',
      component: CompanyProfile
    },
    {
      path: '/products',
      name: 'ProductsPage',
      component: ProductsPage
    },
    {
      path: '/productDetail',
      name: 'ProductsDetail',
      component: ProductsDetail
    },
    {
      path: '/contact',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/successCases',
      name: 'SuccessCases',
      component: SuccessCases
    },
    {
      path: '/salesGuarantee',
      name: 'SalesGuarantee',
      component: SalesGuarantee
    }
  ]
});